import { ResultsRecord } from './unit.model';
import type { ReportProposalSlideKind } from './report-slides.model';

export const DEFAULT_PROPOSAL_NAME = 'Proposal A';

export type ProposalId = string;

/** Id for an action row in {@link Baseline.actions} */
export type ActionId = string;

export type IProposal = {
  id: ProposalId;
  name: string;
  colorIndex: number;
  resultsRecord: ResultsRecord;
  actionIds: ActionId[];
  /**
   * Optional title override on the per-proposal report dashboard page.
   * When unset, {@link IProposal.name} is shown as placeholder text.
   * @deprecated Legacy shared field — prefer {@link report_product_groups_title}.
   */
  report_title?: string;
  /**
   * Optional free-text body shown under the proposal title on the per-proposal
   * report dashboard page. Persisted on the proposal JSONB blob so it travels
   * with the proposal through copies/imports.
   * @deprecated Legacy shared field — prefer {@link report_product_groups_description}.
   */
  report_description?: string;
  /** Hero title on the product-groups report slide. */
  report_product_groups_title?: string;
  /** Hero body on the product-groups report slide. */
  report_product_groups_description?: string;
  /** Hero title on the high-carbon products report slide. */
  report_top_products_title?: string;
  /** Hero body on the high-carbon products report slide. */
  report_top_products_description?: string;
  /** Hero title on the actions report slide. */
  report_actions_title?: string;
  /** Hero body on the actions report slide. */
  report_actions_description?: string;
  /** Per-proposal report slides omitted from the canvas, print, and PDF. */
  report_hidden_slides?: ReportProposalSlideKind[];
};
